import { Row, Col, Button, Upload } from 'antd';
import React, { useState, useEffect } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { get, toString, includes, size } from 'lodash';
import { useParams } from 'react-router-dom';
import ProcImageViewButton from './ProcImageViewButton';
import { reactLocalStorage } from 'reactjs-localstorage';
import MyService from '../../functions/service';

type Proc = {
  proc_id: number;
  proc_name: string;
};
type Props = {
  proc: Proc;
  userImage: never[];
  onUploadSuccess: (uploadSuccess: boolean) => void;
};
let fileList: Array<string> = [];

function CustomerDetailProc(props: Props) {
  const customer = useParams<any>();
  const customerId = customer.customerId;

  const [hasImage, setHasImage] = useState(false);
  let maxIndex = 0;

  useEffect(() => {
    checkHasImage();
  }, []);

  useEffect(() => {
    checkHasImage();
  }, [props.userImage]);

  function checkHasImage() {
    maxIndex = 0;
    props.userImage.forEach((image) => {
      if (image['proc_id'] === props.proc.proc_id) {
        setHasImage(true);
        if (image['proc_img_indx'] > maxIndex) {
          maxIndex = image['proc_img_indx'];
        }
      }
    });
  }

  async function handleChangeFile(files: any) {
    console.log(fileList);
    const user = reactLocalStorage.getObject('user.info');
    if (!user) return null;
    var token = get(user, 'user_acc_tokn');
    if (size(files) > 0) {
      for (var i = 0; i < size(files); i++) {
        if (includes(fileList, files[i].uid) === false) {
          fileList.push(files[i].uid);
          const formData = new FormData();
          formData.set('user_acc_id', toString(customerId));
          formData.set('photo', files[i].originFileObj, files[i].name);
          const index = maxIndex + i + 1;
          const result = await MyService.postRequestData(
            `/users/procedures/${props.proc.proc_id}/upload/${index}`,
            formData,
            token
          ).catch((err) => console.log(err));
          if (result) {
            props.onUploadSuccess(true);
          }
        }
      }
    }
  }

  return (
    <>
      <div key={props.proc.proc_id} className="my-2">
        <Row gutter={[16, 16]}>
          <Col span={4}>
            <div>{props.proc.proc_name}</div>
          </Col>
          <Col span={10}>
            {hasImage ? (
              <ProcImageViewButton
                procId={props.proc.proc_id}
                userImage={props.userImage}
              />
            ) : (
              <p>Chưa cung cấp</p>
            )}
          </Col>
          <Col span={6}></Col>
          <Col span={4}>
            <Upload
              listType="picture"
              multiple={true}
              beforeUpload={() => {
                return false;
              }}
              onChange={(response) => handleChangeFile(response.fileList)}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>Tải lên</Button>
            </Upload>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default CustomerDetailProc;
